import { defineStore } from 'pinia';

export const useDataStore = defineStore('dataStore', {
  state: () => ({
    data: [],
    language: JSON.parse(localStorage.getItem('myAppData'))?.language || 'en', // Default language is English
  }),

  actions: {
    fetchData() {
      // No-op or load static data if needed
      console.log('Using static data, no fetch needed.');
    },
    setLanguage(newLanguage) {
      this.language = newLanguage;
      localStorage.setItem('myAppData', JSON.stringify({
        ...JSON.parse(localStorage.getItem('myAppData') || '{}'),
        language: newLanguage,
      }));

      // إعادة تحميل البيانات للغة الجديدة
      this.fetchData();
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'myAppData',
        storage: localStorage,
      },
    ],
  },
});
